// Helpers shared by the generation-config UI (checkpoint cards + custom rules).

// Resolve a value's display label from a backend {value, label} option list.
export const option_label = (options, value) => {
  const found = (options || []).find((o) => o.value === value);
  return found ? found.label : value;
};

// Render a custom rule's summary string — mirrors the backend's
// buildCustomName, which names the generated checklists, e.g.
// "Custom: No bookings in last 2 weeks + Signup: Last month + Plan type: PC".
export const build_rule_summary = (rule, meta) => {
  const m = meta || {};
  const f = rule.filters || {};
  const parts = [`Custom: ${option_label(m.condition_options, rule.condition)}`];
  if (f.signup_window && f.signup_window !== 'all_time') {
    parts.push(`Signup: ${option_label(m.signup_options, f.signup_window)}`);
  }
  if (f.prepay_type && f.prepay_type.length) {
    parts.push(`Prepay: ${f.prepay_type.map((v) => option_label(m.prepay_options, v)).join(', ')}`);
  }
  if (f.plan_type && f.plan_type.length) {
    parts.push(`Plan type: ${f.plan_type.join(', ')}`);
  }
  if (f.account_status && f.account_status.length) {
    parts.push(`Status: ${f.account_status.join(', ')}`);
  }
  return parts.join(' + ');
};

// Human description of a "No + conditions" checkpoint rule for the card hint
// line, e.g. "Generates only for members matching: Prepay Monthly AND Plan PC".
export const conditions_summary = (conditions, meta) => {
  const m = meta || {};
  const c = conditions || {};
  const parts = [];
  if (c.prepay_type && c.prepay_type.length) {
    parts.push(`Prepay ${c.prepay_type.map((v) => option_label(m.prepay_options, v)).join('/')}`);
  }
  if (c.plan_type && c.plan_type.length) {
    parts.push(`Plan ${c.plan_type.join('/')}`);
  }
  if (c.account_status && c.account_status.length) {
    parts.push(`Status ${c.account_status.join('/')}`);
  }
  return parts.join(' AND ');
};

// Default shape for a freshly-added custom rule (id assigned by the server on
// save).
export const new_custom_rule = () => ({
  id: '',
  enabled: true,
  condition: 'cancel_noshow_over_25pct',
  filters: {
    signup_window: 'all_time',
    prepay_type: [],
    plan_type: [],
    account_status: []
  }
});
